import { motion } from "framer-motion";
import { ArrowUp, Instagram, Phone } from "lucide-react";
import Stamp from "./Stamp";
import { PHONE_TEL, INSTAGRAM_URL, scrollToSection } from "../lib/scroll";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-eggshell pt-20 sm:pt-28 pb-10 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-10 mb-16 sm:mb-24">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold mb-4">
              Still hungry?
            </p>
            <p className="font-garamond italic text-2xl sm:text-3xl leading-snug max-w-md text-eggshell/85">
              The oven is already warm. One message and your box is on the
              batch list.
            </p>
          </div>
          <Stamp light size={132} />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1 }}
          className="font-display font-black leading-[0.85] tracking-tight select-none"
          aria-label="Zoni's Bakehouse"
        >
          <span className="block text-[19vw] sm:text-[15vw] text-stroke-eggshell hover:text-eggshell transition-colors duration-700" data-testid="footer-giant-wordmark">
            ZONI&apos;S
          </span>
          <span className="block text-[19vw] sm:text-[15vw] italic text-gold/90">
            Bakehouse
          </span>
        </motion.h2>

        <div className="mt-14 sm:mt-20 border-t border-eggshell/15 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-eggshell/50">
            © {year} Zoni&apos;s Bakehouse — Dadar, Mumbai
          </p>
          <div className="flex items-center gap-6">
            <a
              href={PHONE_TEL}
              data-testid="footer-phone-link"
              aria-label="Call Zoni's Bakehouse"
              className="text-eggshell/60 hover:text-gold transition-colors duration-300"
            >
              <Phone size={17} />
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Zoni's Bakehouse on Instagram"
              className="text-eggshell/60 hover:text-gold transition-colors duration-300"
            >
              <Instagram size={17} />
            </a>
            <button
              onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.6 }) : window.scrollTo({ top: 0, behavior: "smooth" })}
              data-testid="footer-back-to-top"
              className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-eggshell/60 hover:text-gold transition-colors duration-300"
            >
              Back to top <ArrowUp size={14} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
